import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
// Importa el locale español
import localeEs from '@angular/common/locales/es';
import { APP_INITIALIZER, ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { AppCommonModule } from '@common/app-common.module';
import { AnalyticsService } from '@common/services';
import { AuthInterceptorService } from '@modules/auth/services';
import { CreditosSharedModule } from '@modules/creditos/creditos-shared.module';
import { CreditBlockedInterceptor } from '@modules/creditos/services/credit-blocked.interceptor';
import { NavigationModule } from '@modules/navigation/navigation.module';
import { OnboardingModule } from '@modules/onboarding/onboarding.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from 'environments/environment';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { GlobalErrorHandler } from './services/global-error.handler';

// Registra el locale español
registerLocaleData(localeEs);

// Factory function for APP_INITIALIZER
function initializeAnalytics(analyticsService: AnalyticsService) {
    return () => analyticsService.initialize();
}

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        NgxSliderModule,
        AppCommonModule.forRoot(),
        NavigationModule.forRoot(),
        OnboardingModule,
        // Módulo eager con el modal de bloqueo + banner pre/post vencimiento del módulo Créditos.
        // Se importa acá para que el interceptor 423 pueda abrir el modal en cualquier ruta;
        // los lazy modules que necesiten el banner (home dashboard) lo importan por separado.
        CreditosSharedModule,
        StoreModule.forRoot({}),
        EffectsModule.forRoot([]),
        StoreDevtoolsModule.instrument({
            maxAge: 25,
            logOnly: environment.production,
        }),
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true },
        // Captura HTTP 423 del módulo Créditos y dispara el modal de bloqueo global.
        { provide: HTTP_INTERCEPTORS, useClass: CreditBlockedInterceptor, multi: true },
        { provide: LOCALE_ID, useValue: 'es-ES' }, // Añade esta línea para configurar el locale a español
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        {
            provide: APP_INITIALIZER,
            useFactory: initializeAnalytics,
            deps: [AnalyticsService],
            multi: true,
        },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
